import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_match_type_value = _resolveComponent("match-type-value");
  const _component_WrapWithSectionItem = _resolveComponent("WrapWithSectionItem");
  return _openBlock(), _createBlock(_component_WrapWithSectionItem, {
    selected: $props.selected,
    onSelect: _cache[0] || (_cache[0] = $event => _ctx.$emit('select', {
      id: $props.id
    })),
    onDeselect: _cache[1] || (_cache[1] = $event => _ctx.$emit('deselect', {
      id: $props.id
    })),
    onSelectOnly: _cache[2] || (_cache[2] = $event => _ctx.$emit('selectOnly', {
      id: $props.id
    }))
  }, {
    default: _withCtx(() => [_createVNode(_component_match_type_value, {
      type: $props.type,
      name: $props.name,
      query: $props.query
    }, null, 8, ["type", "name", "query"])]),
    _: 1
  }, 8, ["selected"]);
}